import { Injectable } from '@angular/core';

const TOKEN_KEY = 'anonymous_tracking_jwt';
const TKT_H_KEY = 'anonymous_tracking_tkt_h';
const EXP_KEY = 'anonymous_tracking_exp';
const ROL_KEY = 'anonymous_tracking_rol';


/**
 * JWT y metadatos del flujo de seguimiento anónimo.
 * Separado de {@link TransportistaSessionStorage} para evitar mezclar credenciales.
 */
@Injectable({ providedIn: 'root' })
export class AnonymousSessionStorage {
  setSession(token: string, tktH: string, expUnix?: number): void {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(TKT_H_KEY, tktH);
    if (expUnix != null) {
      localStorage.setItem(EXP_KEY, String(expUnix));
    } else {
      const parsed = this.parseJwtExp(token);
      if (parsed != null) {
        localStorage.setItem(EXP_KEY, String(parsed));
      } else {
        localStorage.removeItem(EXP_KEY);
      }
    }
  }

  getToken(): string | null {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  }

  getAuthorizedTicket(): string | null {
    try {
      return localStorage.getItem(TKT_H_KEY);
    } catch {
      return null;
    }
  }

  setRol(rol: string | null | undefined): void {
    if (rol) {
      localStorage.setItem(ROL_KEY, rol);
    } else {
      localStorage.removeItem(ROL_KEY);
    }
  }

  getRol(): string | null {
    try {
      return localStorage.getItem(ROL_KEY);
    } catch {
      return null;
    }
  }

  isExpired(): boolean {
    try {
      const raw = localStorage.getItem(EXP_KEY);
      if (!raw) {
        return false;
      }
      const exp = Number(raw);
      if (!Number.isFinite(exp)) {
        return false;
      }
      return Date.now() >= exp * 1000;
    } catch {
      return false;
    }
  }

  clearAll(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TKT_H_KEY);
    localStorage.removeItem(EXP_KEY);
    localStorage.removeItem(ROL_KEY);
  }

  private parseJwtExp(token: string): number | null {
    try {
      const parts = token.split('.');
      if (parts.length < 2) {
        return null;
      }
      const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
      const exp = payload?.exp;
      return typeof exp === 'number' ? exp : null;
    } catch {
      return null;
    }
  }
}
